export enum StatoLiberatoria {
  approvata = 'APPROVATA',
  rigettata = 'RIGETTATA',
  attesa = 'ATTESA',
}
